module.exports = __webpack_public_path__ + "b447638c9b51eb3c16aaf3c7895f61c7.jpg";